import {
  add_uploaded_icon_option,
  get_incident_types_table,
  handle_icon_upload,
  has_authority_id,
  is_icon_option_selected,
  map_authority,
  select_icon_option,
} from "@/views/manage_incident/manage_incident_helper";

export default {
  add_uploaded_icon_option,
  get_incident_types_table,
  handle_icon_upload,
  has_authority_id,
  is_icon_option_selected,
  map_authority,
  select_icon_option,
};
